import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '../../helpers/useQuery';
import JobPageContainer from './JobPageContainer';
import { useSelector } from 'react-redux';
import { AppState } from '../../store/state/appState';
import { getCreateJobNameFromAppState } from '../../store/selectors/createJobSelectors';

export default function JobAudioErrorPage() {
	const params = useParams<any>();
	const engagementId = parseInt(params.engagementId);
	const name = useSelector<AppState, string>(s => getCreateJobNameFromAppState(s, engagementId));
	const query = useQuery();
	const error = query.get('type') as (JobAudioErrorType | nundefined);
	const rawJobId = query.get('jobId');
	const jobId = rawJobId ? parseInt(rawJobId) : null;
	
	return (
		<JobPageContainer engagementId={engagementId} jobName={name} progressStatus="upload">
			<div className="page-container">
				<h1 className="h1-mb-1 text-center">{getErrorMessage()}</h1>
				<div className="text-center">
					Please <Link to={`/engagements/${engagementId}/jobs/${jobId ?? 'create'}`}>try again</Link> or contact <a href="mailto:support@tethr.com">support@tethr.com</a> for assistance.
				</div>
			</div>
		</JobPageContainer>
	);
	
	function getErrorMessage(): string {
		switch (error) {
			case 'inconsistent':
				return 'Your participant orientation is not consistent';
			case 'unsupported':
				return 'Your participant orientation is not supported';
			default:
				return 'Creovai could not determine the orientation of your audio';
		}
	}
}

export type JobAudioErrorType = 'inconsistent' | 'undetermined' | 'unsupported';